import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { formatIsoDay, formatTRY } from "@/lib/format";
import { KonumBadge } from "@/components/finance/KonumDialog";

// v1.39.0 Portföyden Çek/Senet seçici: Portföyde (Şirkette + tüm Banka Kasaları), arama, konum filtresi, çoklu seçim, seçili toplam. Yalnız TL seçilebilir.
export default function InstrumentPicker({ picked, onChange }) {
  const [q, setQ] = useState("");
  const [konum, setKonum] = useState("");
  const [items, setItems] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/cek-senet", { params: { status: "portfoyde", q, konum, page_size: 200 } }).then(({ data }) => setItems(data.items)).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, [q, konum]);
  const toggle = (i) => onChange(picked[i.id] ? Object.fromEntries(Object.entries(picked).filter(([k]) => k !== i.id)) : { ...picked, [i.id]: i });
  const sel = Object.values(picked);
  const total = sel.reduce((s, i) => s + i.amount, 0);
  return (
    <div className="col-span-2 space-y-2 rounded border border-violet-200 bg-violet-50/30 p-2" data-testid="prim-instrument-picker">
      <div className="flex flex-wrap items-center gap-2 text-[12px]">
        <Input className="h-8 w-56" placeholder="Evrak no, cari, keşideci…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="prim-instr-search" />
        {[["", "Tümü"], ["sirket", "Şirkette"], ["banka_kasasi", "Banka Kasası"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setKonum(k)} className={`rounded-full border px-2.5 py-0.5 ${konum === k ? "border-slate-900 bg-slate-900 text-white" : "bg-white"}`} data-testid={`prim-instr-konum-${k || "all"}`}>{l}</button>))}
        <span className="ml-auto font-semibold" data-testid="prim-instr-total">{sel.length} evrak · {formatTRY(total)}</span>
      </div>
      <div className="max-h-56 overflow-y-auto rounded border bg-white">
        <table className="dense-table w-full text-[12px]"><thead><tr><th /><th>Konum</th><th>Evrak No</th><th>Tür</th><th>Keşideci / Cari</th><th>Banka</th><th className="text-right">Tutar</th><th>Vade</th></tr></thead>
          <tbody>{!items ? <tr><td colSpan={8} className="py-4 text-center text-slate-400">Yükleniyor…</td></tr> : items.length === 0 ? <tr><td colSpan={8} className="py-4 text-center text-slate-400">Portföyde evrak yok</td></tr> : items.map((i) => {
            const fx = (i.currency || "TRY") !== "TRY";
            return (
              <tr key={i.id} className={fx ? "opacity-50" : "cursor-pointer"} onClick={() => !fx && toggle(i)} title={fx ? "Prim ödemesinde yalnız TL evrak kullanılabilir" : ""} data-testid={`prim-instr-row-${i.portfolio_no}`}>
                <td><input type="checkbox" disabled={fx} checked={!!picked[i.id]} readOnly data-testid={`prim-instr-pick-${i.portfolio_no}`} /></td>
                <td><KonumBadge i={i} /></td><td className="font-mono">{i.portfolio_no}</td><td>{i.kind_label}</td>
                <td className="max-w-[180px] truncate">{i.drawer_name}<div className="text-[11px] text-slate-500">{i.customer_title}</div></td><td>{i.bank_name || "—"}</td>
                <td className="text-right font-mono">{fx ? `${i.amount.toLocaleString("tr-TR")} ${i.currency}` : formatTRY(i.amount)}</td><td className="font-mono">{formatIsoDay(i.due_date)}</td>
              </tr>);
          })}</tbody></table>
      </div>
    </div>
  );
}
